import { useNavigate } from 'react-router-dom';
import UserInfo from './components/UserInfoSection';
import Parents from './components/ParentsSection';
import Children from './components/ChildrenSection';
import Footer from '../../home/components/Footer';
import { 
  User,          // 기본 정보 (아이디)
  Key,           // 비밀번호
  Users,         // 부모 영역 (가족/그룹)
  CreditCard,    // 자녀 영역 (여권 카드 형태)
  PlusCircle,    // 추가 버튼 (부모/자녀 추가)
  ChevronRight,  // (선택 사항) 상세 페이지 이동 시
  ShieldCheck    // (선택 사항) 인증 상태 표시 시
} from 'lucide-react';
const MyPage = () => {
	const navigate = useNavigate();

	return (
		<div className="min-h-screen bg-gray-50">
			<nav className="bg-white shadow-sm sticky top-0 z-50">
				<div className="max-w-7xl mx-auto px-4 py-4">
					<div className="flex items-center justify-between">
						<button onClick={() => navigate(-1)} className="flex items-center space-x-2 text-gray-700 hover:text-purple-600 transition-colors cursor-pointer">
							<i className="ri-arrow-left-line text-xl"></i>
							<span className="font-bold text-xl">AIKnow 라이브 클래스</span>
						</button>
					</div>
				</div>
			</nav>
			<section className="min-h-[80vh] py-12 bg-gradient-to-br from-purple-600 to-blue-600">
				<div className="text-center mb-10">
					<h2 className="text-3xl md:text-4xl font-bold text-white tracking-tight">
						마이페이지
					</h2>
					<p className="text-white/80 mt-2 text-sm">
						회원정보를 확인 및 변경할 수 있습니다.
					</p>
				</div>
      			<div className="max-w-[900px] mx-auto overflow-hidden text-center relative rounded-none md:rounded-[20px] bg-white/95 backdrop-blur rounded-2xl shadow-xl border border-white/20">
      				<div className="p-8 md:p-12 space-y-12 text-left">
	      				<UserInfo/>
	      				<Parents/>
	      				<Children/>
	      				<div className="p-8 bg-gray-50 border-t flex justify-end gap-3">
	      					<button className="px-6 py-2 rounded-lg text-gray-500 font-medium hover:bg-gray-200">로그아웃</button>
	      					<button className="px-6 py-2 rounded-lg bg-blue-600 text-white font-bold hover:bg-blue-700 shadow-lg shadow-blue-200">정보 저장</button>
	      				</div>
	      			</div>
        		</div>
        	</section>
			<Footer/>
		</div>
	);
}

export default MyPage;